import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import de from 'vuetify/es5/locale/de';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      // Navy für Fokus, Auswahl, Schalter, Checkboxen und Datumspicker. Orange ist kein Theme-Token, sondern nur
      // --acc in den eigenen Bausteinen (Ort, Primärknopf, aktueller Wert); Spezifikation 2.7.
      light: {
        primary: '#2B7BB9',
        secondary: '#5B6472',
        accent: '#2B7BB9',
        error: '#B42318',
        info: '#2B7BB9',
        success: '#2E9D5B',
        warning: '#8A5A00'
      },
      // Dunkles Farbschema (Kundenwunsch 12.10.2026; docs/redesign/umsetzung.md, Nachtrag 12.10.2026 Nr. 15). Aktiv nur,
      // solange die Shell eingehängt ist: $vuetify.theme.dark setzt ausschließlich src/shell/farbschema.js. Werte wie die
      // Dunkelwerte in src/css/redesign/tokens.css: primary, accent, info = --link; secondary = --ink-3; error = --red;
      // success = --green-dot; warning = --amber. Ohne diesen Eintrag gälten Vuetifys Standardfarben (primary #2196F3,
      // accent #FF4081), auch für die Linkfarbe. Schrift auf diesen Farbflächen: --on-link (src/css/redesign/vuetify.css).
      dark: {
        primary: '#85B9E0',
        secondary: '#99A2AD',
        accent: '#85B9E0',
        error: '#F6837A',
        info: '#85B9E0',
        success: '#2E9D5B',
        warning: '#E0A53E'
      },
    },
  },
    lang: {
      locales: { de },
      current: 'de',
    },
});
